export default __webpack_public_path__ + "static/gallery-award-silverdistinction-eb7f8c052894feeadd5c0cd54110d4e8.jpg";